import { ReactElement, useCallback } from 'react';

import { WidgetsDto } from 'src/models/widgets.dto';

import { ErrorElementOnInjected } from './ErrorElementOnInjected';
import { WidgetHead } from './WidgetHead';
import { WidgetInjected } from './WidgetInjected';
import { SkeletonBody } from './WidgetSkeleton/SkeletonBody';
import styles from './styles.module.scss';

export function Widget({
  service,
  host_url,
  component_id,
  name,
  help,
  urls,
}: WidgetsDto): ReactElement {
  const errorElement = useCallback(
    (_: boolean | string, rebuild: () => void) => (
      <ErrorElementOnInjected rebuild={rebuild} />
    ),
    []
  );

  return (
    <li className={styles.widget}>
      <WidgetHead service={service} name={name} help={help} urls={urls} />

      <WidgetInjected
        host={host_url}
        name={component_id}
        errorElement={errorElement}
        fallback={<SkeletonBody />}
      />
    </li>
  );
}
